import React from 'react';
import Content from '../Content';

export default function ArticleContent({ content }) {
  return (
    <Content html={content} />
  )
}
